




















	import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
    import { store, CDR, StoreState } from '../store';
    import VueElementLoading from 'vue-element-loading';
    import {RotateSquare2} from 'vue-loading-spinner';
    import { mapState } from 'vuex';
    import util from '../lib/util';

	@Component({
        components: {
            RotateSquare2,VueElementLoading
		},
		computed: {
			...mapState({
                'devices': (state: StoreState) => (state.account as any).devices,
			})
		}
    })
	export default class LogOut extends Vue {
        

        data() {
            return {
                is_loading: false,
                selectedDevice: null,
            }
        }

        get login_sts(){
          var varb = window.location.pathname =='/login'? false:true;
          console.log('verb',varb);
          console.log('window.location.pathname',window.location.pathname);
          return varb;
        }

       async log_out(){
         //this.$store.commit('LOGOUT_STATUS' , false);  
          window.location.reload();
         await this.$store.dispatch('logout')
         //this.$store.dispatch("verifyJWT"); 
         
       }
	}
